import React from "react";
import styled from "styled-components";
import HighlightPill from "./HighlightPill";

const TitleWrapper = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  text-transform: uppercase;
  color: ${(p) => p.maincolor || "var(--my-color3)"};
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  justify-content: center;
`;

const HighlightTitle = ({
  text,
  highlightWord = null,
  angle = "0deg",
  bg = "var(--my-color4)",
  textColor = "#ffffff",
  rotateText = false,
  mainTextColor = "var(--my-color3)",
}) => {
  if (!text) return null;

  const words = text.split(" ");
  let rendered;

  if (highlightWord && text.includes(highlightWord)) {
    rendered = text.split(highlightWord).reduce((acc, part, idx, arr) => {
      acc.push(part.trim());
      if (idx !== arr.length - 1) {
        acc.push(
          <HighlightPill
            key={idx}
            angle={angle}
            bg={bg}
            rotateText={rotateText}
            textColor={textColor}
          >
            {highlightWord}
          </HighlightPill>
        );
      }
      return acc;
    }, []);
  } else {
    // highlight first word by default
    const [first, ...rest] = words;
    rendered = [
      <HighlightPill
        key={0}
        angle={angle}
        bg={bg}
        rotateText={rotateText}
        textColor={textColor}
      >
        {first}
      </HighlightPill>,
      " ",
      rest.join(" "),
    ];
  }

  return <TitleWrapper maincolor={mainTextColor}>{rendered}</TitleWrapper>;
};

export default HighlightTitle;
